<template>
  <div class="container pt-4">
    <h1 class="mb-3" style="text-align: center">Fotogalerie</h1>
    <div class="row">
      <div class="col-md-3  pb-3" v-for="(image, i) in images" :key="i">
        <div class="card h-100">
          <div>
            <img
              class="card-img-top embed-responsive-item gallery-img"
              style="height: 230px"
              :src="image.url"
              :alt="image.alt"
              @click="index = i"
            />
          </div>
          <div class="card-body">
            <p class="card-text" style="text-align: center; font-style: italic">{{image.alt}}</p>
          </div>
        </div>
      </div>
    </div>
    <vue-gallery-slideshow
      :images="images"
      :index="index"
      @close="index = null"
    ></vue-gallery-slideshow>
  </div>
</template>

<script>
import VueGallerySlideshow from "vue-gallery-slideshow";

export default {
  name: "photogallery",
  components: {
    VueGallerySlideshow,
  },
  data: function () {
    return {
      images: [
        { url: require('@/assets/galerie/pohled_z_venku_1.jpg'), alt: "Pohled z venku #1" },
        { url: require('@/assets/galerie/pohled_z_venku_2.jpg'), alt: "Pohled z venku #2" },
        { url: require('@/assets/galerie/pohled_z_venku_3.jpg'), alt: "Pohled z venku #3" },
        { url: require('@/assets/galerie/pohled_z_balkonu_1.jpg'), alt: "Pohled z balkonu #1" },
        { url: require('@/assets/galerie/pohled_z_balkonu_2.jpg'), alt: "Pohled z balkonu #2" },
        { url: require('@/assets/galerie/pohled_z_balkonu_3.jpg'), alt: "Pohled z balkonu #3" },
        { url: require('@/assets/galerie/pohled_z_balkonu_4.jpg'), alt: "Pohled z balkonu #4" },
        { url: require('@/assets/galerie/dvojluzkovy_pokoj_1.jpg'), alt: "Dvojlůžkový pokoj #1" },
        { url: require('@/assets/galerie/dvojluzkovy_pokoj_2.jpg'), alt: "Dvojlůžkový pokoj #2" },
        { url: require('@/assets/galerie/dvojluzkovy_pokoj_jidelni_kout_1.jpg'), alt: "Jídelní kout u dvoulůžkového pokoje #1" },
        { url: require('@/assets/galerie/podkrovni_pokoj_1.jpg'), alt: "Podkrovní pokoj #1" },
        { url: require('@/assets/galerie/podkrovni_pokoj_2.jpg'), alt: "Podkrovní pokoj #2" },
        { url: require('@/assets/galerie/koupelna.jpg'), alt: "Koupelna" },
        { url: require('@/assets/galerie/toaleta.jpg'), alt: "Toaleta" },
        { url: require('@/assets/galerie/kuchynka_1.jpg'), alt: "Kuchyňka #1" },
        { url: require('@/assets/galerie/kuchynka_2.jpg'), alt: "Kuchyňka #2" },
        { url: require('@/assets/galerie/balkon.jpg'), alt: "Balkon" },
        { url: require('@/assets/galerie/venkovni_posezeni.jpg'), alt: "Venkovní posezení" },
        { url: require('@/assets/galerie/ohniste_1.jpg'), alt: "Ohniště #1" },
        { url: require('@/assets/galerie/ohniste_2.jpg'), alt: "Ohniště #2" }
      ],
      index: null,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .gallery-img {
    object-fit: cover;
  }
</style>
